import { render, staticRenderFns } from "./ComponentCategory.vue?vue&type=template&id=663ad6ac"
import script from "./ComponentCategory.vue?vue&type=script&lang=js"
export * from "./ComponentCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports